import { Dispatch, SetStateAction } from 'react';
import { Col, Row } from 'react-bootstrap';
import info from '../../../../assets/images/icons/info.svg';
import FilterRadioButton from '../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../components/FilterRadioButtonsContainer';
import { Container, Group } from '../styles';

interface MyLinkSettingsTabI {
  sendAnswerOfClaimToCollabEmail: boolean,
  setSendAnswerOfClaimToCollabEmail: Dispatch<SetStateAction<boolean>>,
  allowCollabToSeeLetter: boolean,
  setAllowCollabToSeeLetter: Dispatch<SetStateAction<boolean>>,
  allowMultipleConsults: boolean,
  setAllowMultipleConsults: Dispatch<SetStateAction<boolean>>,
  usesCustomLogo: boolean,
  setUsesCustomLogo: Dispatch<SetStateAction<boolean>>,
  integrateWithWs: boolean,
  setIntegrateWithWs: Dispatch<SetStateAction<boolean>>,
  setIsMyLinkFull: Dispatch<SetStateAction<boolean>>,
  isMyLinkFull: boolean,
  verifySalaryRJ: boolean,
  setVerifySalaryRJ: Dispatch<SetStateAction<boolean>>,
  mustSendAddressProof: boolean,
  setMustSendAddressProof: Dispatch<SetStateAction<boolean>>,
}

export default function MyLinkSettingsTab({
  sendAnswerOfClaimToCollabEmail,
  setSendAnswerOfClaimToCollabEmail,
  allowCollabToSeeLetter,
  setAllowCollabToSeeLetter,
  allowMultipleConsults,
  setAllowMultipleConsults,
  usesCustomLogo,
  setUsesCustomLogo,
  integrateWithWs,
  setIntegrateWithWs,
  setIsMyLinkFull,
  isMyLinkFull,
  verifySalaryRJ,
  setVerifySalaryRJ,
  mustSendAddressProof,
  setMustSendAddressProof,
}: MyLinkSettingsTabI) {
  return (
    <Row xs={1} md={1} lg={1}>
      <Col>
        <Container>
          <div className="card-title">
            Configurações My-Link
          </div>
          <Group>
            <div className="title">
              <div>
                Notificar resposta de contestação ao colaborador por E-mail?
                {' '}
                <img src={info} alt="info" title="Habilitar esta opção enviará automaticamente um e-mail ao colaborador com a resposta ao resultado da contestação do processo de roteirização. Quando ativada, o sistema enviará um e-mail de notificação ao colaborador informando sobre o resultado da contestação e quaisquer ações adicionais necessárias." />
              </div>
            </div>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={sendAnswerOfClaimToCollabEmail}
                onClick={() => setSendAnswerOfClaimToCollabEmail(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!sendAnswerOfClaimToCollabEmail}
                onClick={() => setSendAnswerOfClaimToCollabEmail(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>

          <Group>
            <div className="title">
              <div>
                Permitir visualização e envio da Carta com resultado para Colaborador?
                {' '}
                <img src={info} alt="info" title="Ativar esta opção permitirá a visualização e o envio da carta com o resultado para o colaborador. Quando habilitada, o sistema possibilitará que o colaborador visualize a carta contendo informações sobre o resultado, bem como a opção de enviar a carta diretamente a ele. " />
              </div>
            </div>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={allowCollabToSeeLetter}
                onClick={() => setAllowCollabToSeeLetter(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!allowCollabToSeeLetter}
                onClick={() => setAllowCollabToSeeLetter(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>

          <Group>
            <div className="title">
              <div>
                Permitir que o colaborador faça Novas Roteirizações?
                {' '}
                <img src={info} alt="info" title="Ativar esta opção permitirá que o colaborador realize mais que uma roteirização. Quando habilitada, o sistema possibilitará que o colaborador realize uma nova roteirização via My-Link, mediante envio de comprovante de residência, caso o endereço residencial do mesmo tenha sido alterado. " />
              </div>
            </div>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={allowMultipleConsults}
                onClick={() => setAllowMultipleConsults(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!allowMultipleConsults}
                onClick={() => setAllowMultipleConsults(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>

          <Group>
            <div className="title">
              <div>
                Utilizar logomarca própria?
                {' '}
                <img src={info} alt="info" title="Ativar esta opção trocará a logomarca da Capta pela logomarca da empresa no My-Link." />
              </div>
            </div>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={usesCustomLogo}
                onClick={() => setUsesCustomLogo(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!usesCustomLogo}
                onClick={() => setUsesCustomLogo(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>

          <Group>
            <div className="title">
              <div>
                Enviar dados Roteirização via Web Consulta após Aceite do Resultado?
                {' '}
                <img src={info} alt="info" title="Ativar esta opção habilitará a integração do My-Link via Web Service." />
              </div>
            </div>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={integrateWithWs}
                onClick={() => setIntegrateWithWs(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!integrateWithWs}
                onClick={() => setIntegrateWithWs(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>

          <Group>
            <div className="title">
              <div>
                Usa My-Link Full?
                {' '}
                <img src={info} alt="info" title="Ativar esta opção habilitará o My-Link full, que possui um comportamento diferente em relação às consultas fora de abrangência. Nesse caso, abrirá a possibilidade do usuário informar os bilhetes que utiliza manualmente, selecionando Região, Operadora, e por fim o bilhete." />
              </div>
            </div>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={isMyLinkFull}
                onClick={() => setIsMyLinkFull(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!isMyLinkFull}
                onClick={() => setIsMyLinkFull(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>

          <Group>
            <div className="title">
              <div>
                Verificar salário RJ?
                {' '}
                <img src={info} alt="info" title="Ativar esta opção habilitará a funcionalidade para perguntar sobre o salário do colaborador quando o endereço for do RJ. Isso acarretará na decisão de usar ou não a integração para a consulta, de acordo com a resposta do funcionário. Vale ressaltar que a integração será realizada apenas se ele responder que o salário for menor, e se o local de trabalho estiver configurado para realizar integrações." />
              </div>
            </div>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={verifySalaryRJ}
                onClick={() => setVerifySalaryRJ(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!verifySalaryRJ}
                onClick={() => setVerifySalaryRJ(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>

          <Group>
            <div className="title">
              <div>
                Quando endereço é alterado, exige anexar comprovante de residência atualizado?
                {' '}
                <img src={info} alt="info" title="Se é identificado que o mesmo CPF dentro da empresa no My-Link tem um endereço diferente de uma consulta anterior realizada, define se obrigará o usuário a anexar um comprovante de endereço atualizado contendo o novo endereço por ele informado." />
              </div>
            </div>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={mustSendAddressProof}
                onClick={() => setMustSendAddressProof(true)}
              >
                  Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!mustSendAddressProof}
                onClick={() => setMustSendAddressProof(false)}
              >
                  Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </Group>
        </Container>
      </Col>
    </Row>
  );
}
